interface ITextInputContext {
  input: HTMLInputElement | HTMLTextAreaElement;
  disabled: boolean;
  commit: (value: string) => void;
}

/** Shared plain-text editing commands for single- and multiline fields. */
export const textInputContextMenuItems = ({ input, disabled, commit }: ITextInputContext) => {
  const selectedText = () => input.value.substring(input.selectionStart ?? 0, input.selectionEnd ?? 0);
  const replaceSelection = (text: string) => {
    if (disabled || input.disabled) return;
    input.setRangeText(text, input.selectionStart ?? 0, input.selectionEnd ?? 0, 'end');
    commit(input.value);
  };
  return [
    { name: 'Cut', iconName: 'lucide:Scissors', shortcut: 'Cmd+X', disabled: disabled || !selectedText(), action: async () => {
      if (disabled || input.disabled) return;
      await navigator.clipboard.writeText(selectedText());
      replaceSelection('');
    } },
    { name: 'Copy', iconName: 'lucide:Copy', shortcut: 'Cmd+C', disabled: !selectedText(), action: async () => {
      await navigator.clipboard.writeText(selectedText());
    } },
    { name: 'Paste', iconName: 'lucide:ClipboardPaste', shortcut: 'Cmd+V', disabled, action: async () => {
      if (disabled || input.disabled) return;
      replaceSelection(await navigator.clipboard.readText());
    } },
    { divider: true as const },
    { name: 'Select All', iconName: 'lucide:TextCursorInput', shortcut: 'Cmd+A', action: () => input.select() },
  ];
};
